import type { StepContext, StepId } from "./types";

export const INITIAL_STACK: StepId[] = ["OFFER_PAUSE"];

// Declarative flow definition — each step declares how to compute its next step
export const FLOW: Record<
  StepId,
  { next?: (ctx: StepContext) => StepId | null }
> = {
  OFFER_PAUSE: {
    next: () => "REASONS",
  },
  REASONS: {
    next: (ctx) => (ctx.skipContextual ? "CONFIRM" : "CONTEXTUAL"),
  },
  CONTEXTUAL: {
    next: () => "CONFIRM",
  },
  CONFIRM: {
    // Terminal step — no next
  },
};
